import { render, staticRenderFns } from "./NewsLikesVisor.vue?vue&type=template&id=9c2183bc"
import script from "./NewsLikesVisor.vue?vue&type=script&lang=js"
export * from "./NewsLikesVisor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports